import { render, staticRenderFns } from "./FuelKso.vue?vue&type=template&id=5067af38"
import script from "./FuelKso.vue?vue&type=script&lang=js"
export * from "./FuelKso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports